export const ORDINI_PATH = "/pages/ordini";
export const FATTURE_PATH = "/pages/fatture";
export const DDT_PATH = "/pages/ddt";
export const CREDIT_NOTES_PATH = "/pages/note-di-credito";
export const HOME_PAGE_PATH = "/";
export const CREATE_ORDINI_DETTAGLIO_PATH = (orderId: string) =>
    `/pages/ordini-details?id=${orderId}`;
export const CREATE_FATTURE_DETTAGLIO_PATH = (invoiceId: string) =>
    `/pages/fatture-details?id=${invoiceId}`;
export const CREATE_DDT_DETTAGLIO_PATH = (ddtId: string) =>
    `/pages/ddt-details?id=${ddtId}`;
export const CREATE_CREDIT_NOTE_DETTAGLIO_PATH = (creditNoteId: string) =>
    `/pages/note-credito-details?id=${creditNoteId}`;
export const B2B_SEND_ORDER_PATH = "/pages/b2b-invia-ordine";
export const B2B_STORE_PATH = "/pages/b2b-store";
export const GENERATE_B2B_THANK_YOU_PATH = (param: string) =>
    `/pages/b2b-thank-you?order-number=${param}`;
export const GENERATE_RMA_PATH = (ddtId: string, ddtLineNo: string, documentNumber: string) =>
    `/pages/rma?ddtId=${ddtId}&ddtLineNo=${ddtLineNo}&documentId=${documentNumber}`;
export const RMA_THANK_YOU_PATH = "/pages/rma-thank-you";
